import { Link } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { MeApi } from "../api/services";
import { useAuth } from "../auth/AuthProvider";
import { EmptyState, PageHeader, Spinner } from "../components/common";
import { ago } from "../lib/format";

export default function Notifications() {
  const { user } = useAuth();
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ["notifications"], queryFn: MeApi.notifications });
  const readAll = useMutation({ mutationFn: MeApi.readAll, onSuccess: () => qc.invalidateQueries({ queryKey: ["notifications"] }) });
  const link = (id: string) => (user.role === "patient" ? `/patient/bookings/${id}` : user.role === "responder" ? "/responder" : "/dispatch");

  return (
    <div>
      <PageHeader title="Notifications" action={
        <button className="fp-btn-secondary" onClick={() => readAll.mutate()} data-testid="notifications-read-all-button">Mark all read</button>} />
      {isLoading ? <Spinner /> : !data?.items.length ? <EmptyState title="No notifications yet" testId="notifications-empty" /> : (
        <ul className="space-y-2" data-testid="notifications-list">
          {data.items.map((n: any) => (
            <li key={n.id} className={`fp-card ${n.read ? "" : "border-l-4 border-l-[#036248]"}`} data-testid="notification-item">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className={`font-semibold ${n.kind === "alert" ? "text-amber-800" : "text-slate-900"}`}>{n.title}</p>
                  <p className="text-sm text-slate-600">{n.body}</p>
                  {n.booking_id && <Link to={link(n.booking_id)} className="mt-1 inline-block text-xs font-semibold text-[#036248] underline">Open</Link>}
                </div>
                <span className="shrink-0 text-xs text-slate-400">{ago(n.created_at)}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
